




























































import { Component, Prop, Vue, namespace } from 'nuxt-property-decorator'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { mdiCartOutline } from '@mdi/js'
import { IProductDayItem, IProductToCart } from '~/assets/interfaces/products'
import { ICartItem } from '~/assets/interfaces/cart'
import { CART_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import { filterLinkToProductReviews } from '~/assets/filters/produts'
import ComponentImage from '~/components/images/image.vue'
import ComponentProductDetailPricesLight from '~/components/products/product-detail-prices-light.vue'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import ComponentRating from '~/components/rating/rating.vue'
const cartStore = namespace('cart')

@Component({
  filters: {
    filterLinkToProductReviews,
  },
  components: {
    ComponentImage,
    ComponentProductDetailPricesLight,
    VueCountdown,
    ComponentFormButtonIcon,
    ComponentRating,
  },
})
export default class ComponentProductDay extends Vue {
  @Prop({ type: String, default: 'Товар дня' }) readonly titleBlock!: string
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IProductDayItem

  @cartStore.Action('toCart') private toCart!: (
    product: IProductToCart
  ) => Promise<void>

  @cartStore.State('items') private items!: ICartItem[]

  private icons = {
    mdiCartOutline,
  }

  private get buyButtonTitle() {
    return this.isInCart ? 'Перейти в  корзину' : 'Добавить в корзину'
  }

  private isMounted = false
  private mounted(): void {
    this.isMounted = true
    this.$emit('loaded')
  }

  private get isInCart() {
    return !!this.items.find((item) => {
      return item.id === this.item.id
    })
  }

  private get time() {
    if (this.item.endTime) {
      return Date.parse(this.item.endTime) - Date.now()
    } else {
      return 0
    }
  }

  private isLoading = false

  private async buy() {
    const tempProd = {
      id: this.item.id,
      quantity: 1,
    }

    if (!this.isLoading) {
      this.isLoading = true
      if (this.isInCart) {
        await this.$router.push(filterUrl(CART_PATH))
      } else {
        await this.toCart(tempProd)
      }
    }
    this.isLoading = false
    // comment
  }

  private transformCountDown(
    props: Record<string, number>
  ): Record<string, string> {
    const newProps: Record<string, string> = {}

    Object.entries(props).forEach(([key, value]) => {
      // Adds leading zero
      const digits = value < 10 ? `0${value}` : value

      newProps[key] = `${digits}`
    })

    return newProps
  }
}
